import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { BillingGateService } from '../billing-gate';
import { readCompanyKeyFromPathFromRoot } from '../routing/company-route.util';

/**
 * Enquanto o billing gate estiver ativo, só permite navegar para
 * `/c/:companyKey/empresa/faturamento` (qualquer subrota). Qualquer outra
 * tentativa é redirecionada para o faturamento da empresa atual.
 *
 * Rotas de auth (`/auth/*`) estão fora deste shell e nunca passam por aqui.
 */
export const billingGateChildGuard: CanActivateChildFn = (childRoute, state) => {
  const gate = inject(BillingGateService);
  const router = inject(Router);

  if (!gate.blocked()) return true;

  const companyKey = readCompanyKeyFromPathFromRoot(childRoute);
  const targetPath = state.url.toLowerCase();
  const allowedPrefix = companyKey
    ? `/c/${companyKey.toLowerCase()}/empresa/faturamento`
    : null;

  if (allowedPrefix && targetPath.startsWith(allowedPrefix)) {
    return true;
  }

  if (companyKey) {
    return router.createUrlTree(['/c', companyKey, 'empresa', 'faturamento']);
  }

  return router.createUrlTree(['/auth/login']);
};
